module.exports = __webpack_public_path__ + "static/media/Ruben_Arcas_Navarro.eeb94365.png";